import { CatCategory } from "@firmament-packages/categories"

const categoryBlack2IconsMap: Record<string, string> = {
    "class": "/images/ic_info_fitness_class_black_2.svg",
    "tour": "/images/ic_info_tour_black_2.svg",
    "workshop": "/images/ic_info_workshop_black_2.svg",
    "watch_party": "/images/ic_info_watch_party_black_2.svg",

    "default": "ic_info_fitness_class_black_2.svg",
}
const categoryTertiaryIconsMap: Record<string, string> = {
    "class": "/images/ic_info_fitness_class_tertiary.svg",
    "tour": "/images/ic_info_tour_tertiary.svg",
    "workshop": "/images/ic_info_workshop_tertiary.svg",
    "watch_party": "/images/ic_info_watch_party_tertiary.svg",

    "default": "/images/ic_info_fitness_class_tertiary.svg",
}

declare module "@firmament-packages/categories" {
    interface CatCategory {
        defaultIconSrc(variant: "secondary" | "tertiary"): string | undefined
    }
}

CatCategory.prototype.defaultIconSrc = function(variant: "secondary" | "tertiary") {
    switch (this.categoryType) {
        case "MEETING_TYPE":
            return variant === "secondary"
                ? categoryBlack2IconsMap[this.slug || "default"]
                : categoryTertiaryIconsMap[this.slug || "default"]
        default:
            return undefined
    }
}
